/* istanbul ignore next */
/* Code coverage having problems with no statements in classes */
export class SkyColumnSelectorContext {
  public columns: Array<SkyColumnSelectorModel>;
  public selectedColumnIds: Array<string>;
}

/* istanbul ignore next */
/* Code coverage having problems with no statements in classes */
export class SkyColumnSelectorModel {
  public id: string;
  public heading: string;
  public description: string;
}
